import { Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { manpowerTiers } from "../../data/content";

export const ManpowerSolutions = ({ dark = true }) => (
    <section className={`relative ${dark ? "bg-navy grain" : "bg-white"}`} data-testid="manpower-solutions">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
            <SectionHeading
                dark={dark}
                overline="Manpower Solutions"
                title="Manpower Solutions for Every Business Requirement"
                subtitle="FRONTX provides manpower across multiple skill categories — from unskilled workforce to skilled professionals — scalable to any volume."
            />
            <Stagger className="mt-14 grid lg:grid-cols-3 gap-6">
                {manpowerTiers.map((t, i) => (
                    <StaggerItem key={t.title}>
                        <div className={`h-full p-8 rounded-sm border relative overflow-hidden group ${
                            dark ? "bg-slate-800 border-white/10" : "bg-[#f8fafc] border-slate-200"
                        }`}>
                            <div className="absolute top-0 left-0 h-1 w-full bg-brand scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                            <div className="flex items-center gap-4">
                                <div className="h-14 w-14 rounded-sm grid place-items-center bg-brand/15">
                                    <t.icon size={30} weight="duotone" className="text-brand" />
                                </div>
                                <span className="font-display font-extrabold text-5xl text-white/5 ml-auto">{String(i + 1).padStart(2, "0")}</span>
                            </div>
                            <h3 className={`mt-6 font-display font-bold text-xl tracking-tight ${dark ? "text-white" : "text-navy"}`}>{t.title}</h3>
                            <div className="mt-5 flex flex-wrap gap-2">
                                {t.roles.map((r) => (
                                    <span key={r} className={`text-xs px-3 py-1.5 rounded-sm ${
                                        dark ? "bg-white/5 text-slate-300 border border-white/10" : "bg-white text-slate-600 border border-slate-200"
                                    }`}>{r}</span>
                                ))}
                            </div>
                        </div>
                    </StaggerItem>
                ))}
            </Stagger>
        </div>
    </section>
);
